import {tns} from "tiny-slider";

export default class HeroSlider {

	getCarouselOptions(item) {
		return {
			autoplay: false,
			autoWidth: false,
			axis: "horizontal",
			container: item,
			controls: false,
			items: 1,
			nav: true,
			mode: 'carousel',
			slideBy: 1,
			autoplayButton: false,
			autoplayButtonOutput: false,
			loop: false,
			speed: 500,
			gutter: 50,
			mouseDrag: true,
			controlsContainer: false,
			touch: true,
		};
	}

	triggerCarousel() {
		const blocks = document.querySelectorAll(".hero-slider-once");
		if (blocks.length) {
			[...blocks].forEach((block) => {
					const slider = block.querySelector(".card__container");
					let options = this.getCarouselOptions(slider);
					let carousel = tns(options);
				}
			);
		}
	}

	init() {
		this.triggerCarousel();
	}
}

const heroSlider = new HeroSlider();

export function initHeroSlider() {
	heroSlider.init();
}
